import React from 'react';
import abys from './img/middleContent/abys.jpg';
import as from './img/middleContent/as.jpg';
import hyundai from './img/pc2.png';

function MiddleContent({history}) {
    
    const hyundai1 = {
        backgroundImage: `url(${hyundai})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        paddingTop: "90px",
        paddingBottom: "90px"
    }
    const as1 = {
        backgroundImage: `url(${as})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        paddingTop: "90px",
        paddingBottom: "90px"
    }
    const abys1 = {
        backgroundImage: `url(${abys})`,
        backgroundSize: "cover",
        backgroundPosition: "center top",
        paddingTop: "90px",
        paddingBottom: "90px"
    }
    const btn = {
        borderRadius: "20px",
        fontWeight:"bold"
    }
    return (
        <div className="container-fluid text-center p-0">
            <div className="row p-0">
                <div className="col-4 bg_move bg_move2" style={as1}>
                    <div className="mt-4 middle_text2">썬가드하이퍼이벤트</div>
                    <div className="btn btn-outline-light px-5 py-2 mt-5 font_up" onClick={() => {history.push('/serviceall?cate=sungard')}} style={btn}>바로가기</div>
                </div>
                <div className="col-4 bg_move bg_move1" style={hyundai1}>
                    <div className="middle_text1" >현대캐피탈 신차할부<br />신차패키지 서비스</div>
                    <span className="btn btn-outline-light px-5 py-2 mt-5 font_up" onClick={() => {history.push('/serviceall?cate=hyundai')}} style={btn}>바로가기</span>
                </div>
                <div className="col-4 bg_move bg_move3" style={abys1}>
                    <div className="mt-4 middle_text2">SC글로벌 B to B</div>
                    <div className="btn btn-outline-light px-5 py-2 mt-5 font_up" onClick={() => {history.push('/serviceall?cate=BtoB')}} style={btn}>바로가기</div>
                </div>
            </div>
        </div>
    )

}


export default MiddleContent;